"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResponsiveConfig = void 0;
var _react = require("react");
var _responsive = require("../styles/responsive");
var _getResponsiveSpacingStyles = require("../utils/getResponsiveSpacingStyles");
var _linaria = require("../utils/linaria");
const deviceStyles = {
  phone: _responsive.phoneStyles,
  tablet: _responsive.tabletStyles,
  desktop: _responsive.desktopStyles
};
const getDeviceStyles = (deviceConfig, device) => {
  const classNames = [];
  const styleKeys = Object.keys(deviceConfig);
  styleKeys.forEach(style => {
    const value = deviceConfig[style];
    if (style.toString().startsWith('spacing')) {
      const deviceSpacingClasses = (0, _getResponsiveSpacingStyles.getResponsiveSpacingStyles)(device, style, value);
      classNames.push(deviceSpacingClasses);
    } else if (style.toString().startsWith('offset')) {
      const deviceOffsetClasses = (0, _getResponsiveSpacingStyles.getResponsiveSpacingStyles)(device, style, value, true);
      classNames.push(deviceOffsetClasses);
    } else if (style === 'columns') {
      // @ts-expect-error  Can't index every possible phone style
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      classNames.push(deviceStyles[device][style][`columns-${value}`]);
    } else if (style === 'colStart') {
      // @ts-expect-error  Can't index every possible phone style
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      classNames.push(deviceStyles[device][style][`colStart-${value}`]);
    } else if (style === 'colEnd') {
      // @ts-expect-error  Can't index every possible phone style
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      classNames.push(deviceStyles[device][style][`colEnd-${value}`]);
    } else {
      // @ts-expect-error  Can't index every possible phone style
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      classNames.push(deviceStyles[device][style][value]);
    }
  });
  return classNames;
};
const useResponsiveConfig = responsiveConfig => {
  const classNames = (0, _react.useMemo)(() => [], []);
  if (responsiveConfig) {
    const deviceKeys = Object.keys(responsiveConfig);
    deviceKeys === null || deviceKeys === void 0 ? void 0 : deviceKeys.forEach(device => {
      classNames.push(...getDeviceStyles(responsiveConfig[device], device));
    });
  }
  return (0, _react.useMemo)(() => (0, _linaria.cx)(...classNames), [classNames]);
};
exports.useResponsiveConfig = useResponsiveConfig;